import sieviApi from "@/api/sieviApi"
// export const myAction = async ( { commit } ) => {

// }

export const obtainUsersAdministrador = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios`)
        if (data.ok) {
            commit('setUsers', data.users)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const createUser = async ( _, { form } ) => {
    const userForm = {
        nombre: form.name,
        cedula: form.cedula,
        email: form.email,
        estado: form.state,
        programa_academico_id: form.programa_academico_id,
        roles: form.roles,
        hfs_responsable: form.hfs_responsable,
        campus_id: form.campus_id
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.post(`/api/administrador/usuarios`, userForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const editUser = async ( _, { form }) => {
    const userForm = {
        nombre: form.nombre,
        email: form.email,
        cedula: form.cedula,
    }
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/${form.id}`, userForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const activateUser = async ( { commit }, idUser ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/activar/${idUser}`)
        if (data.ok) {
            commit('activateUser', data.usuario)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const deactivateUser = async ( { commit }, idUser ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/desactivar/${idUser}`)
        if (data.ok) {
            commit('deactivateUser', data.usuario)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const assignRoleUser = async ( _, { form, idUser }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/roles/${idUser}`, {roles: form})
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const resetKeyUser = async ( _, idUser ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.put(`/api/administrador/usuarios/clave/${idUser}`)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const obtainPrograms = async ( { commit }, id ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/programas/${id}`)
        if (data.ok) {
            commit('setPrograms', data.programas)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainHfs = async ( { commit } ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/obtener/hfs`)
        if (data.ok) {
            commit('setHfs', data.hfs)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const showUser = async ( { commit }, id) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/${id}`)
        if (data.ok) {
            commit('setCurrentUser', data.usuario)
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainTeachersResponsable = async ( { commit }, { id, campusId, hfsId, programId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/responsable/docentes/${id}/${campusId}/${hfsId}/${programId}`)
        if (data.ok) {
            commit('setTeachers', data.docentes)
            return { ok: true, message: data.message }
        } else {
            commit('setTeachers', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainTeachersAuditor = async ( { commit }, { campusId, programId} ) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/auditor/docentes/${campusId}/${programId}`)
        if (data.ok) {
            commit('setTeachers', data.docentes)
            return { ok: true, message: data.message }
        } else {
            commit('setTeachers', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}

export const obtainUsersStatistics = async ( { commit }) => {
    try {
        await sieviApi.get('/sanctum/csrf-cookie')
        const { data } = await sieviApi.get(`/api/administrador/usuarios/estadisticas`)
        if (data.ok) {
            commit('setUsersStatistics', data.estadisticas)
            return { ok: true, message: data.message }
        } else {
            commit('setUsersStatistics', [])
            return { ok: false, message: data.message }
        }

    } catch (error) {
        return { ok: false, message: error/* .response.data.error.message */ }
    }
}